import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const Footer = () => {
    return (
        <Box component="footer" sx={{ py: 3, px: 2, mt: 'auto', backgroundColor: (theme) => theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800] }}>
            <Typography variant="body2" color="textSecondary" align="center">
                © {new Date().getFullYear()} DAoC Buddy
                <br />
                <Link color="inherit" href="https://discord.gg/ZUSbKeX2aQ">
                    Contact me on Discord
                </Link>
            </Typography>
        </Box>
    );
};

export default Footer;
